import React, { useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus, Gift } from 'lucide-react';
const bonuses = [{
  id: 1,
  title: 'Guía 3-6-9 Correcta',
  description: 'El clásico método de manifestación… pero aplicado con intención real. Aprende cómo usar el 3-6-9 sin parecer robot, y con emoción que tu mente sí integra.',
  items: ['🔢 La estructura exacta: 3 veces en la mañana, 6 en el día, 9 en la noche.', '🧠 Por qué este método activa tu sistema reticular y cambia tu percepción diaria.', '✍️ Cómo escribir afirmaciones creíbles que conecten contigo (no autoengaños).', '❤️ Cómo inyectar emoción real sin fingir "positividad".', '❌ Los 3 errores más comunes (y cómo evitarlos desde el día 1).', '🔄 Técnicas para romper el piloto automático al repetir afirmaciones.', '🧘 Pausas conscientes para reprogramar en momentos de ansiedad.', '🧭 Diferencias entre hacerlo por rutina y hacerlo con intención energética.', '🧩 Ejemplos reales adaptables a tu objetivo.', '🔒 Ritual simple de cierre para anclar antes de dormir.']
}, {
  id: 2,
  title: 'Guía de Manifestación: Edición Especial',
  description: 'Manifestar cuando todo va bien es fácil. Esta guía es para cuando la vida está difícil… y tú sigues eligiendo avanzar.',
  items: ['😵‍💫 Micro-calma para cortar ansiedad en 30 segundos.', '🧘 Afirmaciones que funcionan incluso cuando no crees en nada.', '🛡️ Cómo proteger tu energía del entorno crítico/negativo.', '🔄 Manifestar sin forzarte a "sentirte bien" todo el tiempo.', '💬 Frases para sostener tu visión sin explicarte.', '⚡ Acciones mínimas para resultados reales en medio del caos.', '🧠 Qué hacer cuando estás agotado y sientes que nada funciona.', '🚫 Evitar autoengaño y usar tu dolor como punto de partida.', '✨ Reprogramación sutil con compasión, no perfección.', '🔐 Rutina nocturna para reconectar con tu poder.']
}, {
  id: 3,
  title: 'Checklist 7 Días de Abundancia',
  description: 'Abundancia no es suerte, es dirección diaria. Mini-plan de 7 días con micro-acciones claras.',
  items: ['📅 Plan diario 7 días (sin improvisar).', '⏱️ Rutinas de 2 a 5 minutos.', '🔄 Acciones acumulativas (sin agobio).', '✨ Claridad, energía, intuición y foco desde el día 1.', '🎯 Ideal para salir del estancamiento.', '✅ Checklist para marcar avances.', '🎧 Opciones para acompañar con audio/música ancla.', '💬 Afirmaciones específicas por día.', '🧘 Micro-rituales que caben en cualquier horario.', '💡 Cierre final para integrarlo semanalmente.']
}, {
  id: 4,
  title: 'Biblioteca de Afirmaciones por Objetivo',
  description: 'No es repetir frases vacías. Es reescribir tu mente con intención, con afirmaciones diseñadas para conectar.',
  items: ['🔍 Afirmaciones listas por objetivo (dinero, amor, éxito, calma, etc.).', '🧠 Cómo usarlas en 2 a 5 min al día.', '💬 Versiones suaves para cuando dudas (y está bien).', '🧘 Rutina AM/PM paso a paso.', '✍️ 3-6-9 y 55x5 adaptados a distintos estilos.', '🔄 Cómo sentirlas aunque estés cansado o con duda.', '🧱 Repetición + emoción = cambio real.', '✅ Plantilla editable para copiar/pegar.', '🧩 Combinar con visualización + respiración.', '🔁 Ritmo semanal para no aburrirte.']
}, {
  id: 5,
  title: 'No atraes lo que quieres. Atraes lo que toleras.',
  description: 'Una guía para elevar estándares sin drama ni culpa. Atraer más empieza por dejar de conformarte con menos.',
  items: ['🔍 Detectar lo que toleras en automático (relaciones, hábitos, dinero).', '🧠 Por qué eso bloquea lo que deseas.', '🛑 Exigencia sana vs conformismo emocional.', '🧱 Inventario: qué ya no está alineado (y cómo soltarlo).', '✋ Límites sin drama, culpa ni explicaciones.', '💬 Frases clave para cortar ciclos.', '🧘 Reprogramación diaria para recordar lo que mereces.', '🎯 Mini plan 7 días para fortalecer estándares.', '🔐 Sistema para sostener decisiones incómodas.', '🔄 Identidad nueva: de aguantar a elegir.']
}];
export function BonusesAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-8">
      {/* Header */}
      <div className="text-center mb-4" data-id="element-9">
        <div className="inline-block bg-[#D4AF37]/10 px-4 py-2 rounded-full mb-2" data-id="element-10">
          <span className="text-sm font-bold text-[#D4AF37]" data-id="element-11">
            Incluidos con tu compra HOY
          </span>
        </div>
        <h3 className="text-2xl font-bold text-[#2B0A3D] mb-2" data-id="element-12">
          +5 Bonos de Regalo
        </h3>
        <p className="text-sm text-gray-600" data-id="element-13">
          Toca cada bono para ver lo que incluye 👇
        </p>

        {/* Bonus Books Image */}
        <img src="https://cdn.magicpatterns.com/uploads/17mvxk33QsqBUaCqJ2jzvi/BONOS_-_El_secreto.png" alt="5 Bonos de Regalo" className="w-full rounded-xl mt-4 mb-4 shadow-lg" loading="lazy" width="1200" height="600" data-id="element-14" />
      </div>

      {/* Accordion List */}
      <div className="space-y-3" data-id="element-15">
        {bonuses.map((bonus, index) => <div key={bonus.id} className="border border-gray-200 rounded-xl overflow-hidden bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-16">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-4 text-left hover:bg-gray-50 transition-colors" data-id="element-17">
              <div className="flex items-center gap-3 flex-1" data-id="element-18">
                <div className="w-10 h-10 rounded-full bg-[#D4AF37]/10 flex items-center justify-center flex-shrink-0" data-id="element-19">
                  <Gift className="w-5 h-5 text-[#D4AF37]" data-id="element-20" />
                </div>
                <div className="flex-1" data-id="element-21">
                  <span className="text-xs font-bold text-[#D4AF37] uppercase" data-id="element-22">
                    Bono #{bonus.id}
                  </span>
                  <p className="font-bold text-[#2B0A3D] text-sm md:text-base" data-id="element-23">
                    {bonus.title}
                  </p>
                </div>
              </div>
              <motion.div animate={{
            rotate: openIndex === index ? 180 : 0
          }} transition={{
            duration: 0.3
          }} className="w-8 h-8 rounded-full bg-[#2B0A3D] flex items-center justify-center flex-shrink-0" data-id="element-24">
                {openIndex === index ? <Minus className="w-4 h-4 text-white" data-id="element-25" /> : <Plus className="w-4 h-4 text-white" data-id="element-26" />}
              </motion.div>
            </button>

            <AnimatePresence data-id="element-27">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-28">
                  <div className="px-4 pb-4 pt-2 border-t border-gray-100" data-id="element-29">
                    <p className="text-gray-700 text-sm mb-4 leading-relaxed" data-id="element-30">
                      {bonus.description}
                    </p>
                    <ul className="space-y-2" data-id="element-31">
                      {bonus.items.map((item, idx) => <li key={idx} className="text-sm text-gray-600 leading-relaxed" data-id="element-32">
                          {item}
                        </li>)}
                    </ul>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>

      {/* Footer */}
      <div className="text-center mt-4" data-id="element-33">
        <p className="text-sm text-gray-500" data-id="element-34">
          Acceso inmediato. Descarga digital.
        </p>
      </div>
    </div>;
}